import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import { SubjectsDrawer } from 'app/ProfileRevampPage/components/SubjectsDrawer'
import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'

export const Subjects = () => {
  const { profileData } = useProfile()
  const hasMultipleSubjects = (profileData?.subjects ?? []).length > 1

  const [subjectsDrawerOpen, setSubjectsDrawerOpen] =
    React.useState<boolean>(false)

  const onClickSubjects = () => {
    setSubjectsDrawerOpen(true)
  }

  const onSubjectsCloseButtonClicked = () => {
    setSubjectsDrawerOpen(false)
  }

  return (
    <>
      <div className="grid grid-cols-12">
        <div
          className={clsx(
            hasMultipleSubjects && 'col-span-10',
            !hasMultipleSubjects && 'col-span-12'
          )}
        >
          <div className="flex space-x-0 w-full">
            <Text variant="body-sm" className="truncate">
              {profileData.subjects[0]}
            </Text>
            <Text variant="body-sm" className="flex-none">
              {hasMultipleSubjects &&
                `, +${profileData.subjects.length - 1} mata pelajaran lain`}
            </Text>
          </div>
        </div>
        {hasMultipleSubjects && (
          <div className="col-span-2 text-right">
            <Text
              data-testid="profile-subjects-see-more-button"
              color="primary"
              variant="body-sm"
              className="cursor-pointer"
              onClick={onClickSubjects}
            >
              Lihat
            </Text>
          </div>
        )}
      </div>
      {subjectsDrawerOpen && (
        <SubjectsDrawer
          isOpen={true}
          onClose={() => setSubjectsDrawerOpen(false)}
          onCloseButtonClicked={onSubjectsCloseButtonClicked}
        />
      )}
    </>
  )
}
